<template>
  <v-card flat>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="historicalCards"
        :loading="loading"
        class="elevation-1"
      >
        <template #[`item.giftCardType`]="{ item }">
          {{ item.giftCardType?.name || "Gavekort" }}
        </template>
        <template #[`item.balance`]="{ item }">
          {{ formatCurrency(item.balance, item.currency) }}
        </template>
        <template #[`item.status`]="{ item }">
          <v-chip
            small
            :color="statusColor(item.status)"
            text-color="white"
          >
            {{ statusLabel(item.status) }}
          </v-chip>
        </template>
        <template #[`item.redeemedAt`]="{ item }">
          <span v-if="item.redeemedAt">{{ formatDate(item.redeemedAt) }}</span>
          <span v-else>-</span>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import { IGiftCardDTO, GiftCardStatus } from "@shared/types";
import { userModule } from "@/store/modules/user/userModule";

@Component({
  name: "gift-card-history-tab",
})
export default class GiftCardHistoryTab extends Vue {
  @Prop({ required: true }) historicalCards!: IGiftCardDTO[];
  @Prop({ default: false }) loading!: boolean;

  get headers() {
    return [
      { text: "Kode", value: "code" },
      { text: "Type", value: "giftCardType" },
      { text: "Saldo", value: "balance" },
      { text: "Status", value: "status" },
      { text: "Innløst", value: "redeemedAt" },
    ];
  }

  public formatCurrency(value: number, currency: string | undefined): string {
    const formatter = new Intl.NumberFormat(this.$i18n.locale, {
      style: "currency",
      currency: currency || userModule.user?.currency || "NOK",
    });
    return formatter.format(value);
  }

  public formatDate(date: string | Date | null | undefined): string {
    if (!date) return "-";
    const actual = typeof date === "string" ? new Date(date) : date;
    return actual.toLocaleDateString(this.$i18n.locale);
  }

  public statusLabel(status: GiftCardStatus): string {
    const map: Record<GiftCardStatus, string> = {
      [GiftCardStatus.Generated]: "Generert",
      [GiftCardStatus.Printed]: "Skrevet ut",
      [GiftCardStatus.Active]: "Aktiv",
      [GiftCardStatus.Redeemed]: "Innløst",
      [GiftCardStatus.PartiallyRedeemed]: "Delvis innløst",
      [GiftCardStatus.Expired]: "Utgått",
      [GiftCardStatus.Voided]: "Annullert",
    };
    return map[status];
  }

  public statusColor(status: GiftCardStatus): string {
    switch (status) {
      case GiftCardStatus.Active:
        return "green";
      case GiftCardStatus.Generated:
      case GiftCardStatus.Printed:
        return "blue";
      case GiftCardStatus.Redeemed:
        return "success";
      case GiftCardStatus.Expired:
      case GiftCardStatus.Voided:
        return "grey";
      default:
        return "primary";
    }
  }
}
</script>
